import React from 'react';
import { PropTypes } from 'prop-types';

const TrWithLabelNoValue = ({ item }) => {
  return (
    <tr>
      <td className={`w-44 font-normal text-vamos-gray uppercase ${item.position !== 1 ? 'pt-2' : ''}`}>{item.label}</td>
      <th />
    </tr>
  );
};

TrWithLabelNoValue.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TrWithLabelNoValue;
